// For consent type on tag manager https://support.google.com/tagmanager/answer/10718549?hl=nl
export enum GtagConsent {
	AdStorage = 'ad_storage',
	AdUserData = 'ad_user_data',
	AdPersonalization = 'ad_personalization',
	AnalyticsStorage = 'analytics_storage',
	FunctionalityStorage = 'functionality_storage',
	PersonalizationStorage = 'personalization_storage',
	SecurityStorage = 'security_storage'
}
